import { Box } from 'roo-ui/components';
import styled from '@emotion/styled';

const ScrollWrapper = styled(Box)`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

ScrollWrapper.displayName = 'ScrollWrapper';

const ModalBody = ({ children, ...props }) => <ScrollWrapper {...props}>{children}</ScrollWrapper>;

export default ModalBody;
